<template>
  <a-modal
    :title="title"
    :width="600"
    :visible="isShow"
    :confirm-loading="btnloading"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-form-model ref="formDom" :model="form" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
      <a-form-model-item label="页面路径" prop="page_route">
        <a-input-search
          v-model="form.page_route"
          :maxLength="100"
          placeholder="请输入页面路径"
          enter-button="校验"
          :disabled="isEdit"
          size="default"
          @search="onSearch"
        />
      </a-form-model-item>
      <a-form-model-item label="名称" prop="page_title">
        <a-input v-model="form.page_title" allowClear placeholder="请输入名称" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>
<script>
import { reactive, toRefs, getCurrentInstance, onMounted, watch } from '@vue/composition-api'
import { addForm, rules } from '../business/filialeList'
import dialog from '@/composables/dialog'
import api from '@/api/'

const title = {
  Add: '新增页面',
  Edit: '编辑页面',
}

export default {
  mixins: [dialog],
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    params: {
      type: Object,
      default: null,
    },
    siteId: {
      type: String,
      default: '',
    }
  },
  setup(props, { root }) {
    const _this = getCurrentInstance()
    const state = reactive({
      rules,
      title: title.Add,
      btnloading: false,
      form: { ...addForm },
      isValid: false
    })
    watch(
      () => _this.params,
      async () => {
        const oldForm = JSON.parse(JSON.stringify(_this.params))
        state.form = {
          id: oldForm.id,
          page_route: oldForm.page_route,
          page_title: oldForm.page_title
        }
      }
    )
    onMounted(async () => {
      state.title = _this.isEdit ? title.Edit : title.Add
    })
    const methods = {
      handleSubmit() {
        state.btnloading = true
        _this.$refs.formDom.validate(async (valid) => {
          let res = null
          const data = _this.isEdit ? { id: _this.params.id, page_title: state.form.page_title } : { ...state.form, site_id: _this.siteId }
          if (valid) {
            if (!state.isValid && !_this.isEdit) {
              _this.$message.warning('页面路径校验成功再提交~')
              state.btnloading = false
              return
            }
            if (_this.isEdit) {
              res = await api.cacheSitePageUpdate(data)
            } else {
              res = await api.cacheSitePageCreate(data)
            }
            if (_this.$validate(res)) {
              _this.$message.success(_this.isEdit ? '编辑成功~' : '新增成功~')
              _this.isShow = false
              state.btnloading = false
              _this.$emit('handleOver')
            } else {
              state.btnloading = false
            }
          } else {
            _this.$message.warning('请检查信息是否填写完成')
            state.btnloading = false
          }
        })
      },
      handleCancel() {
        _this.$refs.formDom.resetFields()
        _this.isShow = false
      },
      async onSearch(str) {
        if (str) {
          const res = await api.cacheSitePageCheck({
            site_id: _this.siteId,
            page_route: str,
            id: _this.isEdit ? _this.params.id : ''
          })
          if (res.code === '000000') {
            state.isValid = true
            _this.$message.success('校验成功~')
          } else {
            state.isValid = false
          }
        } else {
          _this.$message.warning('请输入页面路径再校验~')
        }
      }
    }
    return {
      ...toRefs(state),
      ...methods
    }
  }
}
</script>
<style scoped lang="less">
/deep/.ant-form-item-label {
  width: 90px;
}
/deep/.ant-form-item-control-wrapper {
  width: 432px;
}
</style>
